import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'convertAmount',
    standalone: false
})
export class ConvertAmountPipe implements PipeTransform {
  transform(number: number, prefix: string) {
    if (typeof number === 'undefined' || number === null) {
      return '';
    } else if (typeof number !== 'number') {
      return 'Not a number';
    }

    return Math.abs(Number(number)) >= 1.0e12
      ? prefix + ((Number(number) / 1.0e12).toFixed(2) + 'T')
      : Math.abs(Number(number)) >= 1.0e9
      ? prefix + ((Number(number) / 1.0e9).toFixed(2) + 'B')
      : // Six Zeroes for Millions
      Math.abs(Number(number)) >= 1.0e6
      ? prefix + (Number(number) / 1.0e6).toFixed(2) + 'M'
      : // Three Zeroes for Thousands
      Math.abs(Number(number)) >= 1.0e3
      ? prefix + (Number(number) / 1.0e3).toFixed(2) + 'K'
      : prefix + Number(number).toFixed(2);
  }
}
